import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  OnInit,
  signal,
} from '@angular/core';
import { MessageLogs, MessagesService } from '@ubie/core';

@Component({
  selector: 'acl-messages-list',
  standalone: false,
  templateUrl: './messages-list.component.html',
  styleUrl: './messages-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessagesListComponent implements OnInit {
  private readonly messagesService = inject(MessagesService);
  readonly title = input<string>();

  readonly messages = signal<MessageLogs[]>([]);
  readonly currentPage = signal<number>(1); // default page is 1;

  readonly isEmpty = computed(() => this.messages().length === 0);

  ngOnInit(): void {
    this.getMessageLogs();
  }

  sortData(data: MessageLogs[]): MessageLogs[] {
    return data.sort((a, b) => {
      return <any>new Date(b.date) - <any>new Date(a.date);
    });
  }

  getMessageLogs(): void {
    this.messagesService
      .getDashboardLogMessages(this.currentPage())
      .subscribe((response: MessageLogs[]) => {
        this.messages.set(this.sortData(response));
      });
  }

  // page change in pagination
  pageChanged(page: number): void {
    this.currentPage.set(page);
    this.getMessageLogs();
  }
}
